<template>
  <div class="s-canvas" style="height:100%;">
    <canvas id="s-canvas" :width="contentWidth" :height="contentHeight"></canvas>
  </div>
</template>
<script>
export default {
  name: 'SIdentify',
  data(){
    return {

    }
  },
  props: {
    identifyCode: {
      type: String,
      default: '1234'
    },
    fontSizeMin: {
      type: Number,
      default: 16
    },
    fontSizeMax: {
      type: Number,
      default: 40
    },
    backgroundColorMin: {
      type: Number,
      default: 180
    },
    backgroundColorMax: {
      type: Number,
      default: 240
    },
    colorMin: {
      type: Number,
      default: 50
    },
    colorMax: {
      type: Number,
      default: 160
    },
    lineColorMin: {
      type: Number,
      default: 40
    },
    lineColorMax: {
      type: Number,
      default: 180
    },
    dotColorMin: {
      type: Number,
      default: 0
    },
    dotColorMax: {
      type: Number,
      default: 255
    },
    contentWidth: {
      type: Number,
      default: 70
    },
    contentHeight: {
      type: Number,
      default: 25
    }
  },
  methods: {
    // 生成一个随机数
    randomNum (min, max) {
      return Math.floor(Math.random() * (max - min) + min)
    },
    drawPic () {
      const canvas = document.getElementById('s-canvas')
      const ctx = canvas.getContext('2d')
      ctx.textBaseline = 'bottom'
      // 绘制背景
      ctx.fillStyle = 'rgb(250,211,220)'
      ctx.fillRect(0, 0, this.contentWidth, this.contentHeight)
      // 绘制文字
      for (let i = 0; i < this.identifyCode.length; i++) {
        this.drawText(ctx, this.identifyCode[i], i)
      }
    },
    drawText (ctx, txt, i) {
      ctx.fillStyle = 'rgb(51,51,103)';

      ctx.font = '18px SimHei'
      const x = (i + 1) * (this.contentWidth / (this.identifyCode.length + 1))
      // 修改坐标原点和旋转角度
      ctx.translate(x, 22)
      ctx.fillText(txt, 0, 0)
      // 恢复坐标原点和旋转角度
      ctx.translate(-x, -22)
    }
  },
  watch: {
    identifyCode () {
      this.drawPic()
    },
    /* 监听頁面寬度變化*/
  },
  mounted(){
    let _this = this;
    _this.drawPic()
  }
}
</script>